<template>
  <div ref="appRoot">
    <div v-if="isDev" class="tw-absolute tw-top-0 tw-left-[90px] tw-z-700">
      <div class="sm:tw-hidden">xs</div>
      <div class="tw-hidden sm:tw-block md:tw-hidden">sm</div>
      <div class="tw-hidden md:tw-block lg:tw-hidden">md</div>
      <div class="tw-hidden lg:tw-block xl:tw-hidden">lg</div>
      <div class="tw-hidden xl:tw-block">xl</div>
    </div>
    <div class="sf-container">
      <div class="md:tw-flex md:tw-gap-4 lg:tw-gap-16">
        <HeaderLogin class="md:tw-order-2 tw-grow-0 tw-mb-4" />
        <HeaderAlerts v-if="$currentUser.value" class="md:tw-order-1 tw-grow" />
        <div v-else class="md:tw-order-1 tw-grow"></div>
      </div>
    </div>
    <div class="tw-grid tw-grid-cols-2 md:tw-grid-cols-1">
      <HeaderLogo />
      <MainMenu />
    </div>
    <ModalDialog :show="contactVisible" @closed="hideContact">
      <div class="sf-modal-body">
        <ContactForm />
      </div>
    </ModalDialog>
    <ModalDialog :show="faqVisible" @closed="hideFaqs" size="full">
      <div class="sf-modal-body">
        <SfFaq />
      </div>
    </ModalDialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HeaderLogin from "./components/login/HeaderLogin.vue";
import HeaderLogo from "./components/HeaderLogo.vue";
import MainMenu from "./components/main-menu/MainMenu.vue";
import {
  contactVisible,
  faqVisible,
  setContactVisible,
  setFaqVisible,
  setIsV1Legacy,
} from "./state/appState";
import ModalDialog from "./components/ui/ModalDialog.vue";
import ContactForm from "./components/site/ContactForm.vue";
import SfFaq from "./components/site/SfFaq.vue";
import HeaderAlerts from "./components/HeaderAlerts.vue";

export default defineComponent({
  components: {
    HeaderLogin,
    HeaderLogo,
    MainMenu,
    ModalDialog,
    ContactForm,
    SfFaq,
    HeaderAlerts,
  },
  props: { v1legacy: String },
  computed: {
    contactVisible(): boolean {
      return contactVisible.value;
    },
    faqVisible(): boolean {
      return faqVisible.value;
    },
    isDev() {
      return process.env.NODE_ENV == "development";
    },
  },
  mounted() {
    setIsV1Legacy(this.v1legacy == "1");
  },
  methods: {
    hideContact() {
      setContactVisible(false);
    },
    hideFaqs() {
      setFaqVisible(false);
    },
  },
});
</script>
